import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ElementRef, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../services/api.service';
import { Utenteservice } from '../../services/utente.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { confirm } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { ComponentService } from '../../services/component.service';
import { SelectCausaliPosizioniComponent } from '../widgets/select-causali-posizioni/select-causali-posizioni.component';
import { CaptionComponent } from '../caption/caption.component';
import { InfousergruppiComponent } from '../widgets/infousergruppi/infousergruppi.component';

export class _OpzioniAziende{
  idAzienda;
  //Causali: any[][];
  idCausali: any[][];
  causaliPosizioni: any[][];
 
}



@Component({
  selector: 'app-editgruppi',
  templateUrl: './editgruppi.component.html',
  styleUrls: ['./editgruppi.component.css']
})
export class EditgruppiComponent implements OnInit,AfterViewInit {
  @ViewChild('uPermessi', { static: true }) uPermessi: NicaAnagraficaComponent;     
  @ViewChild('dynamicInsertFormComponent', { static: false, read: ViewContainerRef }) dynamicInsertFormComponent: ViewContainerRef;
  @ViewChild('EditGruppiFooter', { static: true }) EditGruppiFooter: CaptionComponent;     
  

  @Input() itemData:any
  isEdit: any;
  itemsCopy:any[]=[]
  StatoAbilitatoPerColonna:any []=[];
  ArrCopiaPermessi:any [] ;
  isDisabled: boolean=true;
  attivoGruppo:boolean=true;
  selectByClick=false;
  popupSelCausali=false;
  UsrSel=1;
  @Input() InviaA: any
  //@Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
  filterValue: any = this.utenteService.GruppiFunzioni[0];
  selAziende:any[]=[];
  selUtenti:any[]=[];
  myFilter:any;
  aziende: any;
  utenti: any;
  nomeGruppo: string;
  listaAccountAbilitati: any;
  listaAziendeAbilitate: any;
  tasks: any;
  desAzienda: any;
  TitleCaus: string;
  ID_AziendaSelezioanta: any;
  utentiAll: any;
  tpsValue;
  tpsUtente=[    
    {
    id:1,
    text:'Utenti Standard'
  },{
    id:2,
    text:'Utenti Advanced'
  }]
  hInstance: any;
  leAziendeCheHoSelezionato:any[]
  leCausaliCheHoSelezionato: any[];
  OpzioniAziende:_OpzioniAziende[]=[]
  lePosizioniCheHoSelezionato: any[];
  constructor(
    private _componentFactoryResolver:ComponentFactoryResolver,
    private camponentService: ComponentService,  
    private spinner: NgxSpinnerService,
    private elem: ElementRef,
    private appService: Apiservice,
    private _overlaySideFormService: OverlaySideFormService,
    public utenteService: Utenteservice) {

      
     }
  ngAfterViewInit(): void {
    if(this.utenteService.temporaryPaste.source=='permessi_utente' && this.utenteService.temporaryPaste.data.length>0)
      this.isDisabled=false;
    this.EditGruppiFooter.isSave=false;
    let elements = this.elem.nativeElement.querySelectorAll('.dx-datagrid-save-button');
    console.log("ECCO LE CALSSI ",elements)
    $(".dx-datagrid-save-button").hide();

    let selector=$('.formEditPopup .dx-overlay-content');
    for (let index = 0; index < selector.length; index++) {
      console.log("Ecco altezza pop "+index,$(selector[index]).height());      
    }
    selector=$('.dx-overlay-content');
    console.log("selettore ",selector);

  }
  onClickChiudo(e){
    //e= save | close;
    if(e=='close') this._overlaySideFormService.close();
    if(e=='15'){ 
    this.uPermessi.griglia.instance.saveEditData();
    }
  }
  onFilterTpsChanged(e){
    this.UsrSel=e.value;
    let flag=e.value
    if(flag==1){
      $("#permessi").show()
      this.utenti=this.utentiAll.filter(ut => (ut.tipoUtente>4 && ut.tipoUtente<11))
    }
    else{
    $("#permessi").hide()
    this.utenti=this.utentiAll.filter(ut => (ut.tipoUtente>3 && ut.tipoUtente<5))
    }
    
  }
  opzioniCasualiPosizioni(e){
    alert("Bhoooooooooooooo!")
  }
  chiudiPopupSelCausali(e){
    if(e=='22'){
      //OpzioniAziende
      let idx=-1;
      let gg1:_OpzioniAziende;
      let aziendaObjP =  this.OpzioniAziende.find(t=>t.idAzienda ===this.ID_AziendaSelezioanta);  

      let PosCaus:any[]=[]     
      this.hInstance.instance.selPosizioni.forEach(function callback(value, index) {
        idx++;
        if(value==undefined){
          //
          
        } else{          
          let gg1
          gg1={
            idCausale:index,
            idPosizioni:value
          }   
            PosCaus.push(gg1)
        }
     
      });
      if(aziendaObjP){
        aziendaObjP.causaliPosizioni=PosCaus; 
        aziendaObjP.idCausali=this.hInstance.instance.selCausali;      
      } else{
        let gg:_OpzioniAziende;
        gg={
          idCausali:this.hInstance.instance.selCausali,
          idAzienda:this.ID_AziendaSelezioanta,
          causaliPosizioni:PosCaus,
        }
        this.OpzioniAziende.push(gg);
      }
      console.log("Causali Selezionate ",this.hInstance.instance.selCausali)
      console.log("Causali Posizioni Selezionate",this.hInstance.instance.selPosizioni)
      
    }

    //this.leAziendeCheHoSelezionato[this.ID_AziendaSelezioanta]
    this.leCausaliCheHoSelezionato=[...this.hInstance.instance.selCausali]
    this.lePosizioniCheHoSelezionato=[...this.hInstance.instance.selPosizioni]

    console.log("causali ",this.hInstance.instance.selCausali)
    console.log("Posizioni ",this.hInstance.instance.selPosizioni)

    console.log("DAAAAAAAAAAAAAA ",e)
    this.popupSelCausali=false
   
    //
  }
  onShowingSelCausali(){
//
  }
  chiudiPopup(){
    this.popupSelCausali=false;
    //
  }
  esuccesso(){
    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'SelectCausaliPosizioniComponent');
    const factory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
    if(this.hInstance){
      this.hInstance.destroy();
      //qua no this.hInstance.instance.causali.length=0;
    }

  

    setTimeout(() => {
      if(this.dynamicInsertFormComponent) {        
        this.dynamicInsertFormComponent.remove();
        this.dynamicInsertFormComponent.clear();
      }
      let hInstance = this.dynamicInsertFormComponent.createComponent(factory, 0);
      //qua no hInstance.instance.causali.length=0;
      setTimeout(() => {
        this.lePosizioniCheHoSelezionato=[];
        let aziendaObjP =  this.OpzioniAziende.find(t=>t.idAzienda ===this.ID_AziendaSelezioanta);          
        if(aziendaObjP)
          this.leCausaliCheHoSelezionato=aziendaObjP.idCausali;
        let tt;
        if(aziendaObjP)
        aziendaObjP.causaliPosizioni.forEach(elem=>{
        
          this.lePosizioniCheHoSelezionato[elem['idCausale']]=elem['idPosizioni']
        })
        console.log("Ecco leeeeeee posizioniiiiiiiii ",this.lePosizioniCheHoSelezionato)
        //hInstance.instance.aggiornaCausali(this.ID_AziendaSelezioanta,this.leCausaliCheHoSelezionato,this.lePosizioniCheHoSelezionato);   
        hInstance.instance.aggiornaCausali(this.ID_AziendaSelezioanta,this.leCausaliCheHoSelezionato,this.lePosizioniCheHoSelezionato);   


      }, 300);
     
      
      this.hInstance=hInstance
      hInstance.instance.emitData.subscribe(
        (val) => {
          if (val) {
            this.dynamicInsertFormComponent.clear();
            this.popupSelCausali = false;
          }
        }
      )

    }, 100);

  }
  nonFunzione(id){
    if(this.hInstance){
      this.hInstance.instance.causali.length=0;
    }
    this.ID_AziendaSelezioanta=id;
   
    this.popupSelCausali = true;

  }

  selUserStd(flag){
      //alert(flag)
      this.UsrSel=flag;
      if(flag==1){
        $("#permessi").show()
        this.utenti=this.utentiAll.filter(ut => (ut.tipoUtente>4 && ut.tipoUtente<11))
      }
      else{
      $("#permessi").hide()
      this.utenti=this.utentiAll.filter(ut => (ut.tipoUtente>3 && ut.tipoUtente<5))
      }

  }
  plusClick(evt,ev){
    //
    console.log("Ho clikkato su opzioni ",evt)
    console.log("Ho clikkato su opzioni ",ev)
    this.desAzienda=evt.descrizione
    this.TitleCaus='Configurazione causali/posizioni Azienda : '+evt.descrizione
    let data:{
      idUser:12;

  }
  

  this.nonFunzione(evt.id)
  

/*  this.camponentService.openComponent("SelectCausaliPosizioniComponent",data,"Foto",800,400,null,this);       
  this.camponentService.outputComponent.subscribe(x=>{            
  }) 
  this.camponentService.dataFromComponent.subscribe(x=>{ // riceve i dati da componente creato

  }) */
  
  ev.event.stopPropagation();



    
  }
  listOnSelectionChangedUser(){
    this.EditGruppiFooter.isSave=this.selUtenti.length>0;
  }
  listOnSelectionChanged(evt){
    console.log("Ho Selezionatoooooooooo ",evt)
    //evt.addedItems
    evt.addedItems.forEach(elem=>{
      let currAziendaObj =  this.aziende.find(t=>t.id ===elem.id);
      if(currAziendaObj) currAziendaObj.checked=true
    })
    //evt.removedItems
    evt.removedItems.forEach(elem=>{
      let currAziendaObj =  this.aziende.find(t=>t.id ===elem.id);
      if(currAziendaObj) currAziendaObj.checked=false
    })


    this.EditGruppiFooter.isSave=this.selAziende.length>0;

    console.log("Ho Selezionatoooooooooo ",this.selAziende)
    console.log("Ho Selezionatoooooooooo ",this.aziende)

    
  }
  ngOnInit() {
      this.aziende=this.utenteService.InfoUtenteConnesso.aziende
      this.StatoAbilitatoPerColonna['inserimento']=false
      this.StatoAbilitatoPerColonna['cancellazione']=false
      this.StatoAbilitatoPerColonna['modifica']=false
      this.StatoAbilitatoPerColonna['visualizzazione']=false
      this.StatoAbilitatoPerColonna['speciale']=false
      
      /*
      const mt=this;
      this.aziende.forEach(item=>{
        let az=item.id;
        mt.appService.GetApi('Token/SetAziendaLavoro?idAzienda='+az).then(data=>{
          console.log("Ecco setta azienda "+item.id+" ",data)
        }).then(function(){
          mt.appService.GetApi('Account?GetUserByLicenze=C001A05').then(data=>{
            console.log("Ecco utenti "+item.id+" ",data)
          })
        })
      })*/
      // Lettura Utenti intera licenza getusebylicenze
///Token/SetAziendaLavoro
     
        var self = this;



        /*this.appService.GetApi('Token/SetAziendaLavoro?idAzienda=1').then(data=>{
          console.log("Ecco setta azienda ",data)
        }).then(function(){
          this.appService.GetApi('Account?GetUserByLicenze='+this.utenteService.InfoUtenteConnesso.licenza.then(data=>{
            console.log("Ecco utenti ",data)
          }))
        })*/

        /*this.appService.GetApi('Account?GetUserByLicenze='+this.utenteService.InfoUtenteConnesso.licenza).then(data=>{
          this.utenti=data['items'];
        })*/


       /* Promise.all([
          this.appService.GetApi('Token/SetAziendaLavoro?idAzienda=1'),
          this.appService.GetApi('Token/SetAziendaLavoro?idAzienda=4')          
        ]).then(function(res) {
          console.log(res[0]);
         console.log(res[1]);
          
        });
     */

    ///Account/GetUserByLicenze
    this.appService.GetApi('Account/GetAllAdvancedAndStandardUsersByLicense?idLicenza='+this.utenteService.InfoUtenteConnesso.licenza).then(data=>{
      this.utenti=data;   
      console.log("Ecco gli utentiiiiiiiiiiiiiiiii ",data)           
    })

    /*
      this.appService.GetApi('Account?idLicenza='+this.utenteService.InfoUtenteConnesso.licenza).then(data=>{
          this.utentiAll=data['items'];
          this.utenti=data['items'].filter(ut => (ut.tipoUtente>4 && ut.tipoUtente<8))
          console.log("Utenti DB ",this.utenti)    
          
    
      })
*/
      this.selUtenti=this.itemData[0].dati.listaAccountAbilitati
      this.selAziende=this.itemData[0].dati.listaAziendeAbilitate
      this.attivoGruppo=this.itemData[0].dati.isAttivo
      console.log("Record  ",this.itemData[0].dati)    
      console.log(" item data ",this.itemData)
      console.log(this.InviaA)
    if(this.itemData)
    {
        if(this.itemData[0]['IdTabella']>-1)
        this.myFilter ="/"+ this.itemData[0]['IdTabella'];
        console.log("Ecco ID ",this.itemData[0])
        //this.myFilter = '/' + this.itemData[0]['idTabRif'];
        this.nomeGruppo=this.itemData[0].dati.descrizione
        console.log(this.itemData[0].dati.descrizione)
        this.OpzioniAziende=this.itemData[0].dati.aziendaCausaliPosizioni       
        setTimeout(() => {
          this.selUtenti=this.itemData[0].dati.listaAccountAbilitati
          //bloccaPermessi
          this.uPermessi.griglia.instance.option('disabled', this.itemData[0].dati.bloccaPermessi);  
        }, 200);
        
    }
    //this.isDisabled=this.utenteService.temporaryPaste.data && this.utenteService.temporaryPaste.data.length >0
  }
  inizializza(){

  }
  onFilterChanged(e) {
    if (e.value.id == 'A') {
      this.uPermessi.griglia.instance.clearFilter();
    } else
      this.uPermessi.griglia.instance.filter(['macroMenu', 'contains', e.value.id]);
    console.log("changed filter ", e)
  }
  checkGetAll(e) {
    let rispo = {
      items: []
    }  
    
    rispo.items = e.data.funzioni;
    let rr={
      "id": 2,
      "idGruppo": 0,
      "idMenuFunzioni": "043",
      "descrizioneuFunzioni": "Anagrafiche Operatori",
      "macroMenu": "R",
      "inserimento": false,
      "modifica": false,
      "cancellazione": false,
      "visualizzazione": false
  }
    rispo.items.unshift(rr);
    return rispo;
    console.log("In Permessi ", e.data[0].dati.funzioni)
    return e.data[0].funzioni;
  }
  buttonEmitted(e){
    console.log(e)
  }
  SalvaGruppo(){
    this.uPermessi.griglia.instance.saveEditData();
  }
  AbilitaDisabilitaColonna(azione,colonna){
    //if(azione=='') return;
    let flag;
    
    /*var dataSource = this.uPermessi.griglia.instance.getDataSource();
    dataSource.load().then(function(data) {
        console.log("ecco tutto ",data);
    });*/


    //const dataSource = this.uPermessi.griglia.instance.getDataSource();
    let elementiInGrid = this.uPermessi.griglia.instance.getVisibleRows(); 
    elementiInGrid.forEach(elemento=>{
      if(elemento['disabled'] !==false)
        this.uPermessi.griglia.instance.cellValue(elemento.rowIndex, colonna, azione)
    })
  }
  AllEvent(e) {
    //onContentReady
    if(e.name=="onRowPrepared"  && e.rowType=="data"){
      if(e.data.disabled==true)
      {
      e.rowElement.classList.add('disabled-row');
      e.rowElement.style.pointerEvents = 'none';
      }
    }

    if(e.name=='onCellPrepared' && e.columnIndex==0 && e.rowType=='data'){
      if(e.row.data.disabled)
        e.cellElement.firstChild.classList.add('dx-icon-g');
      //e.cellElement.style.color = 'gray';
    }


    if(e.name=="onCellPrepared" && e.rowType=='header' && e.dataField=='modifica'){

    }
    if(e.name=="onCellPrepared" && e.rowType=='header' && (e.dataField=='inserimento' || e.dataField=='modifica' || e.dataField=='cancellazione' || e.dataField=='visualizzazione' || e.dataField=='speciale')){
      let exHtnl=e.cellElement.innerText;//='Ins ';
      e.cellElement.innerHTML=exHtnl
      e.cellElement.title='Abilita/Disabilita Colonna'
      //let elementiInGrid = this.uPermessi.griglia.instance.getVisibleRows();     
      let field=e.dataField;
      //const dataSource = this.uPermessi.griglia.instance.getDataSource();
      //const changes = dataSource ? dataSource.store().changes() : [];
      //let elementiInGrid = changes.filter(change => change.type !== 'remove').map(change => change.data);
      // L'ho duplicata ma andrebbe accorpata
      if(e.eventType && e.eventType=="dxclick"){
        let azione=false;
          if(this.StatoAbilitatoPerColonna[field]==true) {
            azione=false;this.StatoAbilitatoPerColonna[field]=false
          }else  if(this.StatoAbilitatoPerColonna[field]==false) {
            azione=true;this.StatoAbilitatoPerColonna[field]=true
          }else{
            //azione='';that.StatoAbilitatoPerColonna['inserimento']=false
            //return;
          }
          this.AbilitaDisabilitaColonna(azione,field);
      }

      //let elementiInGrid = this.uPermessi.griglia.instance.getDataSource().store().getModifiedData();
      //console.log(elementiInGrid) //getDataSource().store().getModifiedData();     
      let newClass='blue'
      let that=this;
      $("<i>")
      .addClass("dx-icon-checklist "+newClass) // Aggiungi le classi delle icone DevExtreme desiderate
      .appendTo(e.cellElement)
      /*.on("click", function() {
          // Logica da eseguire quando l'icona viene cliccata
          let azione=false;
          if(that.StatoAbilitatoPerColonna[field]==true) {
            azione=false;that.StatoAbilitatoPerColonna[field]=false
          }else  if(that.StatoAbilitatoPerColonna[field]==false) {
            azione=true;that.StatoAbilitatoPerColonna[field]=true
          }else{
            //azione='';that.StatoAbilitatoPerColonna['inserimento']=false
            //return;
          }
          that.AbilitaDisabilitaColonna(azione,field);
      });
*/
      //alert("Abilito / Disabilito Colonna inserimento")
    }
    if (e.name == 'onContentReady') {
      if(this.uPermessi.griglia.instance.hasEditData()!=this.isEdit){
        this.isEdit=this.uPermessi.griglia.instance.hasEditData();
        console.log("In Edit ",this.isEdit)
        //this.uPermessi.griglia.instance.repaint();
        $(".dx-datagrid-save-button").attr("style", "display:none");
      }
      
      
    }

    if (e.name == 'preparaToolbar') {
      e.component.columnOption(0, "visible", false);
      this.preparaToolbarCopiaIncolla(e)
    }
    if (e.name == 'onSaved') {
      //console.log("On Saved ", e)
      //console.log("Ecco i dati in griglia  On Saved ", this.uPermessi.griglia.instance.getDataSource());
    }
    if (e.name == 'onSaving') {
      this.uPermessi.griglia.instance.clearFilter();
      e.cancel = true;
      setTimeout(() => {

        e.cancel = true;
        let oldElementInGrid = this.uPermessi.griglia.instance.getDataSource().items();
        //console.log("Ecco i dati in griglia   ",oldElementInGrid);
        e.changes.forEach(element => {
          let obj = oldElementInGrid.find(x => x.id === element.key);
          if (obj && (obj.disabled==false || obj.disabled==undefined)) {
            const r = Object.keys(element.data); // Valori cambiati
            r.forEach(elementKey => {
              obj[elementKey] = element.data[elementKey]
            });
          }
        });
        let dataRecord = {
          isAttivo:this.attivoGruppo,
          id: this.itemData[0].dati.id,
          descrizione:this.nomeGruppo,
          listaAccountAbilitati:this.selUtenti,
          listaAziendeAbilitate:this.selAziende,
          funzioni: oldElementInGrid,
          aziendaCausaliPosizioni:this.OpzioniAziende
        }
        console.log("ecco record ",dataRecord);
        
       
        this.appService.ScriviPermessiGruppo(dataRecord).then(response => {

    this.uPermessi.griglia.instance.cancelEditData();
          //this.currentAzienda = this.newAzienda;
          //this.myFilter = '?idAccount=' + this.currentAccount
          //this.myFilter += '&idAzienda=' + this.currentAzienda;
          //this.filterValue = this.utenteService.GruppiFunzioni[0];
          this.itemData[0]['IdTabella']=response['id'];
          this.myFilter ="/"+ this.itemData[0]['IdTabella'];
          this.uPermessi.refresh();

          //this.currentAzienda=this.newAzienda
          /*
          this.myFilter='?idAccount='+this.currentAccount
          this.myFilter+='&idAzienda='+this.currentAzienda;        
          this.filterValue=this.utenteService.GruppiFunzioni[0];
          this.uPermessi.refresh();
          */
          this.spinner.hide();
          this._overlaySideFormService.close();
          
        }).catch((err: HttpErrorResponse) => {

        });

      }, 200);

    }
  }
  checkIncolla(vv){
    return true;
  }
  optionalButtonGruppi(e){
    console.log("eccoooooooooooo i dati ",e)
    if(e.row.data.disabled) return;
    if(e.row.data.cancellazione==true && 
      e.row.data.inserimento==true &&  
      e.row.data.modifica==true && 
      e.row.data.visualizzazione==true){
        
        this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'cancellazione', false)
        this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'inserimento', false)
        this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'modifica', false)
        this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'visualizzazione', false)
    
    }else{
      
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'cancellazione', true)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'inserimento', true)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'modifica', true)
    this.uPermessi.griglia.instance.cellValue(e.row.rowIndex, 'visualizzazione', true)
    }
  }
  preparaToolbarCopiaIncolla(e) {
    const that = this;
    //---------------------------    
 
    $(".dx-datagrid-save-button").attr("style", "display:none");
    e.toolbarOptions.items.push({
      location: "after",
      widget: 'dxButton',
      cssClass: "",
      options: {
        icon: "fa fa-copy",
        disabled:false,//that.isEdit,
        elementAttr: { title: "Copia Permessi" },
        onClick: function (e: any) {
          //that.ArrCopiaPermessi = that.uPermessi.griglia.instance.getDataSource().items();
          that.ArrCopiaPermessi = that.uPermessi.griglia.instance.getVisibleRows();           
          that.utenteService.temporaryPaste.source='permessi_utente';
          that.utenteService.temporaryPaste.type='array';
          that.utenteService.temporaryPaste.title='Incolla Permessi Utenti';
          //that.utenteService.temporaryPaste.data=Object.assign({}, that.ArrCopiaPermessi);//that.ArrCopiaPermessi;
          //that.utenteService.temporaryPaste.data = Object.entries(that.utenteService.temporaryPaste.data);
          let newArray=[];
          that.ArrCopiaPermessi.forEach(element => {
            let ff={
              dati:element.data,
              rowIndex:element.rowIndex
            }
            newArray.push(ff)
          });
          that.utenteService.temporaryPaste.data=[...newArray];

          console.log("Ho copiato ",that.uPermessi.griglia);
          //that.uPermessi.preparaToolbar(that.uPermessi.griglia);          
          that.isDisabled=false;
          that.uPermessi.griglia.instance.repaint();

          console.log("toolbar ",that.uPermessi.griglia.instance.option('toolbar'))
          // Copia Permessi
        }
      }
    });
    e.toolbarOptions.items.push({
      location: "after",
      widget: 'dxButton',
      cssClass: "bt_incolla verde",
      options: {
        icon: "paste",
        disabled:that.isDisabled,//that.todos$.subscribe() ,//.length==0,
        elementAttr: { title: "Incolla Permessi" },
        onClick: () => {
          if(that.utenteService.temporaryPaste.source.toLowerCase()!='permessi_utente'){
            return
          }
          if (this.utenteService.temporaryPaste.data.length == 0) return;
          let result = confirm("<i>ATTENZIONE! La funzione sostituisce eventuale Permessi già presenti. Pocedere?</i>", "Gruppi");
          result.then((dialogResult) => {
            if (dialogResult) {
              
                that.spinner.show;      
                for(let i=0;i<that.utenteService.temporaryPaste.data.length;i++)
                {
                  let element=that.utenteService.temporaryPaste.data[i]
                  that.uPermessi.griglia.instance.cellValue(element.rowIndex,'inserimento',element.dati.inserimento)
                  that.uPermessi.griglia.instance.cellValue(element.rowIndex,'cancellazione',element.dati.cancellazione)
                  that.uPermessi.griglia.instance.cellValue(element.rowIndex,'modifica',element.dati.modifica)
                  that.uPermessi.griglia.instance.cellValue(element.rowIndex,'visualizzazione',element.dati.visualizzazione)
                  that.uPermessi.griglia.instance.cellValue(element.rowIndex,'speciale',element.dati.speciale)

                }
                /*that.utenteService.temporaryPaste.data.forEach(element => { 
                    that.uPermessi.griglia.instance.cellValue(element.rowIndex,'inserimento',element.data.inserimento)
                    that.uPermessi.griglia.instance.cellValue(element.rowIndex,'cancellazione',element.data.cancellazione)
                    that.uPermessi.griglia.instance.cellValue(element.rowIndex,'modifica',element.data.modifica)
                    that.uPermessi.griglia.instance.cellValue(element.rowIndex,'visualizzazione',element.data.visualizzazione)
                    that.uPermessi.griglia.instance.cellValue(element.rowIndex,'speciale',element.data.speciale)
                });         */
                that.spinner.hide; 
              
             
              return;
              that.uPermessi.griglia.instance.getDataSource().store().load().done((allData)=>{  
                this.utenteService.temporaryPaste.data.forEach(element => { 
                  let r=allData.data.findIndex(elem=>elem.id==element.id)
                  if(r>-1){                  
                    that.uPermessi.griglia.instance.cellValue(r,'inserimento',element.inserimento)
                    that.uPermessi.griglia.instance.cellValue(r,'cancellazione',element.cancellazione)
                    that.uPermessi.griglia.instance.cellValue(r,'modifica',element.modifica)
                    that.uPermessi.griglia.instance.cellValue(r,'visualizzazione',element.visualizzazione)
                  }
                });               
             }); 
            }
          });
        }
      }
    });
    e.toolbarOptions.items.push({
      location: "after",
      widget: 'dxButton',
      options: {
        icon: "clearformat",
        //color: "red",
        elementAttr: { title: "Elimina Tutti i Permessi" },
        onClick: function (e: any) {
          let result = confirm("La funzione cancellerà tutti i permessi presenti. Procedere?", "Copia Permessi");
          result.then((dialogResult) => {
            if (dialogResult) {
              that.spinner.show;
              let elementiInGrid = that.uPermessi.griglia.instance.getVisibleRows();              
              elementiInGrid.forEach(elemento=>{
                that.uPermessi.griglia.instance.cellValue(elemento.rowIndex, 'inserimento', false)
                that.uPermessi.griglia.instance.cellValue(elemento.rowIndex, 'cancellazione', false)
                that.uPermessi.griglia.instance.cellValue(elemento.rowIndex, 'modifica', false)
                that.uPermessi.griglia.instance.cellValue(elemento.rowIndex, 'visualizzazione', false)
                that.uPermessi.griglia.instance.cellValue(elemento.rowIndex, 'speciale', false)
              })              
              /*
              that.uPermessi.griglia.instance.getDataSource().store().load().done((allData)=>{  
                let r=-1;
                allData.data.forEach(element => {
                  r++;
                  that.uPermessi.griglia.instance.cellValue(r,'inserimento',false)
                  that.uPermessi.griglia.instance.cellValue(r,'cancellazione',false)
                  that.uPermessi.griglia.instance.cellValue(r,'modifica',false)
                  that.uPermessi.griglia.instance.cellValue(r,'visualizzazione',false)
                }); 
                
                  //that.uPermessi.griglia.instance.saveEditData();

             });*/ 
            }
          });

        }
      }
    });

    //xxx
    
  }





}

/*
let messaggioChiusura: messagefromComponent = {
        codeMessage: 1,
        destComponent: this.InviaA,
        traceMessage: em.value
      }
      this.userComponentService.emitMessage(messaggioChiusura);

*/
/*
http://rentrincloud.it:8080/api/Account?idLicenza=C001A05
items.nomeCompleto
item.id
*/
